<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">

        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="商品类型" prop="type">
            <el-select
              v-model.number="queryParams.type"
              placeholder="请选择商品类型"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            >
              <el-option v-for="(item, index) in shopType" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>商品列表</span>
          <!--          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">-->
          <!--            <el-col :span="1.5">-->
          <!--              <el-upload-->
          <!--                class="upload-demo"-->
          <!--                :action="sys_app_logoAction"-->
          <!--                accept="xlsx"-->
          <!--                :limit="1"-->
          <!--                :on-success="(res)=>{return importUploadSuccess(res)}"-->
          <!--                :headers="headers"-->
          <!--              >-->
          <!--                <el-button v-permisaction="['config:shopCfg:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>-->
          <!--              </el-upload>-->
          <!--            </el-col>-->
          <!--          </el-row>-->
        </div>

        <el-row :gutter="10" class="mb8" style="margin-top: 10px;">
          <el-col :span="1.5">
            <el-button v-permisaction="['config:shopCfg:add']" icon="el-icon-upload2" size="mini" type="primary" @click="addShop(1)">新增</el-button>
          </el-col>
          <!--          <el-col :span="1.5">-->
          <!--            <el-button-->
          <!--              v-permisaction="['config:shopCfg:export']"-->
          <!--              type="primary"-->
          <!--              icon="el-icon-download"-->
          <!--              size="mini"-->
          <!--              @click="exportData()"-->
          <!--            >导出</el-button>-->
          <!--          </el-col>-->
        </el-row>
        <el-table
          :data="tableData"
          border
          style="width: 100%;"
        >
          <el-table-column
            prop="gid"
            label="商品ID"
          />

          <el-table-column
            prop="gtype"
            label="类型"
            :formatter="typeFormatter"
          />

          <el-table-column
            prop="gname"
            label="名称"
          />

          <el-table-column
            prop="gprice"
            label="价格"
          />

          <el-table-column
            prop="gfirstChargeAddPro"
            label="首冲加赠比例"
          />

          <el-table-column
            prop="gstatus"
            label="商品状态"
            :formatter="statusFormatter"
          />

          <el-table-column
            label="操作"
          >
            <template slot-scope="scope">
              <el-button v-permisaction="['config:shopGoods:edit']" type="text" size="small" @click="addShop(scope.row.gtype, scope.row.gid)">编辑</el-button>
              <el-button v-permisaction="['config:shopGoods:del']" type="text" size="small" @click="del(scope.row.type, scope.row.gid)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables()"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getRewardType } from '@/api/config/lucky-draw'
import {
  deleteShopGoodsCfg,
  exportShopCfg,
  exportShopPrizeCfg,
  getShopGoodsList, getShopType, getSku,
  importShopCfg,
  importShopPrizeCfg,
  updateShopCfg
} from '@/api/config/shop-cfg'
import { getToken } from '@/utils/auth'
export default {
  name: 'ShopGoods',
  data() {
    return {
      activeName: '101',
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        type: ''
      },
      statusType: [{
        value: 1,
        label: '开启'
      }, {
        value: 0,
        label: '关闭'
      }],
      shopType: [],
      options: [[]],
      visibleArr: [{ visible: false }],
      tableData: [
        {
          'id': 0,
          'gid': 0,
          'g_type': 0,
          'desc': '',
          'min_level': 0,
          'max_level': 0,
          'life_time': 0,
          'price': 0,
          'sku': 0,
          'discount': 0,
          'skin_dir': '',
          'status': 0,
          'ss_group': ''
        }
      ],
      formData: [
        {
          'id': 0,
          'gid': 0,
          'g_type': 0,
          'desc': '',
          'min_level': 0,
          'max_level': 0,
          'life_time': 0,
          'price': 0,
          'sku': 0,
          'discount': 0,
          'skin_dir': '',
          'status': 0,
          'ss_group': '',
          'prize_json': [
            {
              type: 1,
              id: 201,
              num: 1
            }
          ]
        }
      ],
      cateType: [],
      selectType: [
        {
          'id': 1,
          'title': '金币'
        },
        {
          'id': 2,
          'title': '体力'
        },
        {
          'id': 3,
          'title': '卡片'
        },
        {
          'id': 4,
          'title': '星星'
        }
      ]
    }
  },
  created() {
    this.getCateType()
    this.getSkuList()
    this.getShopTypeList()
    this.getTables()
  },
  methods: {
    getSkuList() {
      getSku({ type: 2 }).then(res => {
        if (res.code === 200) {
          this.shopSku = []
          res.data.forEach((item) => {
            this.shopSku.push({ label: item.price, value: item.price, sku: item.sku })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getShopTypeList() {
      getShopType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.shopType.push({ label: val, value: parseInt(i) })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleQuery() {
      this.getTables()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    addShop(type, id = 0) {
      this.$router.push({ name: 'ShopGoodsEdit', query: { id: id, type: type }})
    },
    handleClose(d, index) {
      this.visibleArr[index].visible = false
    },
    onSubmit() {
      const data = []
      for (const k in this.formData) {
        const item = this.formData[k]
        if (item.min_level > item.max_level) {
          this.msgError('最低等级不能大于最高等级')
          return
        }

        if (item.price < 0) {
          this.msgError('金额不能小于0')
          return
        }

        if (item.discount < 0) {
          this.msgError('优惠金额不能小于0')
          return
        }
        item.price = parseFloat(item.price)
        item.discount = parseFloat(item.discount)
        data.push(item)
      }
      const postdata = JSON.stringify(data)
      updateShopCfg({ data: postdata }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getShopGoodsList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    addReward(index) {
      console.log('index', this.formData[index])
      this.formData[index].prize_json.push({
        type: 1,
        id: 201,
        num: 1
      })
      const zIndex = this.formData[index].prize_json.length - 1
      console.log('zindex', zIndex)
      this.getRewardList(1, index, zIndex)
    },
    getRewardList(v, index, zIndex) {
      getRewardType({ id: v }).then(res => {
        if (res.code === 200) {
          console.log('add Option', index, zIndex)
          // this.options[index][zIndex] = res.data
          this.$set(this.options[index], zIndex, res.data)

          console.log(this.options[index])
        } else {
          console.log(res.msg)
        }
      })
    },
    removeReward(index, zIndex) {
      this.formData[index].prize_json = this.formData[index].prize_json.filter((item, i) => {
        return i !== zIndex
      })
    },
    getCateType() {
      // getShopType().then(res => {
      //   if (res.code === 200) {
      //     res.data.forEach((item, index) => {
      //       this.cateType.push({ label: item, value: index })
      //     })
      //   } else {
      //     this.msgError(res.msg)
      //   }
      // })
    },
    del(key, id) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteShopGoodsCfg({ id: id }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.getTables(key)
            } else {
              this.msgError(res.msg)
            }
          })
        })
      }
    },
    exportData(type, name) {
      exportShopCfg({ type: type, name: name }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportPrizeData() {
      exportShopPrizeCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importUploadSuccess(response) {
      importShopCfg({ data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importPrizeUploadSuccess(response) {
      importShopPrizeCfg({ data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    statusFormatter(row) {
      if (row.status === 0) {
        return '下架'
      }
      return '上架'
    }, handleClick(tab, event) {
      console.log(tab.name)
      this.getTables(tab.name)
    }, goodsFormatter(row) {
      let str = ''
      const type = parseInt(row.gtype)
      console.log(row)
      switch (type) {
        case 1:
          str += '体力 * ' + row.gbaseReward
          if (row.gfirstPurchase > 0) {
            str += ' 首购赠送 *' + row.gfirstPurchase
          }
          break

        case 2:
          str += '金币 * ' + row.gbaseReward
          if (row.gfirstPurchase > 0) {
            str += ' 首购赠送 *' + row.gfirstPurchase
          }
          break

        case 3:
          str += '宝箱 * ' + row.gbaseReward
          if (row.gfirstPurchase > 0) {
            str += ' 首购赠送 *' + row.gfirstPurchase
          }
          break
      }
      return str
    }, typeFormatter(row, c) {
      let str = ''
      for (const i in this.shopType) {
        const val = this.shopType[i]

        if (val.value === row.gtype) {
          str = val.label
          break
        }
      }
      return str
    }
  }
}
</script>

<style scoped>
</style>
